import {Bom} from "../../../model/job/Bom";
import {BillOfMaterialsPreview} from "../../../model/job/BillOfMaterialsPreview";

/**
 * Job Bill of Materials fetched action.
 */
export const BILL_OF_MATERIALS_FETCHED = "BILL_OF_MATERIALS_FETCHED";
export type BILL_OF_MATERIALS_FETCHED = { bom: Bom, jobId: string };

/**
 * Bill of Materials details removed action.
 */
export const BILL_OF_MATERIAL_REMOVED = "BILL_OF_MATERIAL_REMOVED";
export type BILL_OF_MATERIAL_REMOVED = { jobId: string };

/**
 * Job Bills of Materials fetched action.
 */
export const BILLS_OF_MATERIALS_FETCHED = "BILLS_OF_MATERIALS_FETCHED";
export type BILLS_OF_MATERIALS_FETCHED = { boms: BillOfMaterialsPreview[], jobId: string };